/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Settings_Stripe_SubtitleInputs */

const en_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your Stripe account to receive payments directly.`)
};

const es_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tu cuenta de Stripe para recibir pagos directamente.`)
};

const fr_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez votre compte Stripe pour recevoir des paiements directement.`)
};

const de_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dein Stripe-Konto, um Zahlungen direkt zu erhalten.`)
};

const ja_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払いを直接受け取るにはStripeアカウントを接続してください。`)
};

const zh_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接您的 Stripe 账号以直接接收付款。`)
};

const ar_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربط حساب Stripe الخاص بك لتلقي المدفوعات مباشرة.`)
};

const id_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan akun Stripe Anda untuk menerima pembayaran secara langsung.`)
};

const it_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connetti il tuo account Stripe per ricevere i pagamenti direttamente.`)
};

const ru_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите аккаунт Stripe для получения платежей напрямую.`)
};

const pt_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte sua conta do Stripe para receber pagamentos diretamente.`)
};

const ko_seller_settings_stripe_subtitle = /** @type {(inputs: Seller_Settings_Stripe_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대금을 직접 받으려면 Stripe 계정을 연결하세요.`)
};

/**
* | output |
* | --- |
* | "Connect your Stripe account to receive payments directly." |
*
* @param {Seller_Settings_Stripe_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_settings_stripe_subtitle = /** @type {((inputs?: Seller_Settings_Stripe_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Settings_Stripe_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_settings_stripe_subtitle(inputs)
	if (locale === "es") return es_seller_settings_stripe_subtitle(inputs)
	if (locale === "fr") return fr_seller_settings_stripe_subtitle(inputs)
	if (locale === "de") return de_seller_settings_stripe_subtitle(inputs)
	if (locale === "ja") return ja_seller_settings_stripe_subtitle(inputs)
	if (locale === "zh") return zh_seller_settings_stripe_subtitle(inputs)
	if (locale === "ar") return ar_seller_settings_stripe_subtitle(inputs)
	if (locale === "id") return id_seller_settings_stripe_subtitle(inputs)
	if (locale === "it") return it_seller_settings_stripe_subtitle(inputs)
	if (locale === "ru") return ru_seller_settings_stripe_subtitle(inputs)
	if (locale === "pt") return pt_seller_settings_stripe_subtitle(inputs)
	return ko_seller_settings_stripe_subtitle(inputs)
});